import { ASSET_OPTION } from "@/constants/enums/SensorsParameters";
import GeneratingUnitFeaturesModule from "./GeneratingUnitFeaturesModule";

const getters = {

	/**
	 * Determina a área do ativo com base nas features ativas no sistema.
 	 * @returns {string} Retorna a área do ativo, podendo ser `ASSET_OPTION.HUB` ou `ASSET_OPTION.NACELLE`.
	 */
	resolveAssetAreaByFeature()
	{
		const drivetrainFeatures = GeneratingUnitFeaturesModule.state.DRIVETRAIN;
		const hubFeatures = GeneratingUnitFeaturesModule.state.HUB;

		if (!drivetrainFeatures.GLOBAL_VALUES && hubFeatures.GLOBAL_VALUES)
		{
			return  ASSET_OPTION.HUB;
		}

		return ASSET_OPTION.NACELLE;
	},
};

export default { getters };